import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import Countdown from 'react-countdown';

const Timer: FC<{ label: string; time: number }> = ({ label, time }) => (
  <div className="flex flex-1 flex-col text-center">
    <p className="text-lg font-bold">
      {time.toString().length < 2 ? `0${time}` : time}
    </p>
    <p className="text-xs">{label}</p>
  </div>
);

interface ProductCountdownProps {
  date?: string | null;
}

export const ProductCountdown: FC<ProductCountdownProps> = ({ date = '' }) => {
  const { t } = useTranslation('product');

  if (!date) {
    return null;
  }

  return (
    <div className="mb-6 flex w-full flex-col px-3 text-center">
      <div className="mb-3 w-full py-3">
        <Countdown
          date={date}
          renderer={({ days, hours, minutes, seconds }) => {
            return (
              <div className="flex w-full">
                {days > 2 ? (
                  <>
                    <Timer label="days" time={days} />
                    <Timer label="hours" time={hours} />
                  </>
                ) : (
                  <Timer label="hours" time={days * 24 + hours} />
                )}
                <Timer label="minutes" time={minutes} />
                <Timer label="seconds" time={seconds} />
              </div>
            );
          }}
        />
      </div>
      <p className="text-xs text-neutral-4">
        {t('subscriptionCta.timed.countdownHelpText')}
      </p>
    </div>
  );
};
